import { render, staticRenderFns } from "./TestimonialLogin.vue?vue&type=template&id=1dd90bb3"
import script from "./TestimonialLogin.vue?vue&type=script&lang=js"
export * from "./TestimonialLogin.vue?vue&type=script&lang=js"
import style0 from "./TestimonialLogin.vue?vue&type=style&index=0&id=1dd90bb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports